<div
  class="d-inline-flex align-items-start flex-column input-text-sizing"
  [ngClass]="{ 'disabled-field': control.disabled }"
  [formGroup]="parentFormGroup"
>
  <div class="field-label" *ngIf="formElementModel.label">
    {{ formElementModel.label + asterisk }}
  </div>
  <mat-form-field
    [ngClass]="{ 'editor inline-editable-editor': !control.disabled }"
    floatLabel="auto"
    [hideRequiredMarker]="true"
    [matTooltip]="tooltip"
    matTooltipPosition="left"
  >
    <input
      type="text"
      matInput
      placeholder="{{ formElementModel.placeholder }}"
      formControlName="{{ formElementModel.id }}"
    />
  </mat-form-field>
  <app-validation-error
    [control]="control"
    [formElementModel]="formElementModel"
  ></app-validation-error>
</div>
